const constants = { baseURL: process.env.REACT_APP_API_URL };

export default constants;
